import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { uploadFileAzure } from "cms/integration/azure/storage/azure-storage";
import { useAuth } from "cms/auth/hooks/use-auth";
import { Logger } from "cms/utils/log/logger";

const useUploadFile = () => {
    
    const { token } = useAuth();
    // ---------------------------------------------------------------
    // main upload function
    // ---------------------------------------------------------------
    
    const uploadFile = async (props) => {
        
        const {
            document,
            file,
            file_name,
            onDocumentUploaded,
            setUploadStatus,
        } = props;
        
        // await requestMSALToken()
        // setUploading(true)
        let updated_document;
        
        // get an User Delegate SAS - for Azure Storage Blob
        const sas_response = await SimpliCityAdminSDK.document.getToken(token);
        // Token has configuration available inside
        const {
            sas,
            // storageAccountName,
            storageAccount,
            containerName,
            // fileUrlBase
        } = sas_response;
        // Logger.debug('SAS TOKEN', sas)
        
        // *** UPLOAD TO AZURE STORAGE ***
        Logger.debug(`Uploading file: ${file_name}`);
        setUploadStatus({ status: "INCOMPLETE", message: "The upload has begun." });
        const uploadResult = await uploadFileAzure(storageAccount, containerName, file, sas);
        setUploadStatus(uploadResult);
        if (uploadResult.status === "ERROR") {
            Logger.error(uploadResult);
            throw Error(uploadResult.message);
        } else {
            updated_document = {
                guid: document?.guid,
                title: document?.title,
                description: document?.description,
                storage_account: document?.storage_account,
                storage_container: containerName,
                storage_filepath: document?.storage_filepath,
                storage_url: document?.storage_url,
                link_text: document?.link_text,
                type: document?.type,
                url: document?.url,
                file_name: document?.file_name,
                file_ext: document?.ext,
                file_type: file.type,
                file_size: file.size,
                language: document?.language,
                retention_months: document?.retention_months,
                public: document?.public === 1,
                archived: document?.archived === 1,
                audience: document?.audience,
                doc_id: document?.doc_id,
                external_id: document?.external_id,
                classification: document?.classification,
                sub_classification: document?.sub_classification,
                owner: document?.owner,
                author: document?.author,
            };
        }
        onDocumentUploaded(updated_document);
        // setUploading(false)
    };
    
    return {
        uploadFile
    };
    
};

export { useUploadFile };
